import request from '@/utils/request'

// 所有收藏专家
export function getCollect(data) {
	return request({
		url:'/app-api/biz/my/get-collect-expertPage',
		method: 'get',
		params: data
	})
}